<template>
    <Frame name="账号管理">
        <Head title="绑定店长"></Head>
        <div class="bindAccount">
            <Form class="pop-common-form" :form="bindForm" @submit="handleSubmit">
                <FormItem class="form-item" label="门店名称" :colon="false" v-bind="formItemLayoutCenter">
                    <span class="form-item-value">{{info.bussinessName}}</span>
                </FormItem>
                <FormItem class="form-item" label="绑定手机" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
                    <Input v-decorator="['phone',
                    {
                        rules: rules.phone,
                    }
                    ]"
                    placeholder="请输入手机号" maxlength="11"
                    />
                    <div class="form-help" v-show="showHelp.phone"><img src="../../assets/images/icon-tip.jpg">{{showHelp.phoneText}}</div>
                </FormItem>
                <template v-if="isBind">
                    <FormItem class="form-item" label="账户昵称" :colon="false" v-bind="formItemLayoutCenter">
                        <span>{{info.userName}}</span>
                    </FormItem>
                    <FormItem class="form-item" label="绑定邮箱" :colon="false" v-bind="formItemLayoutCenter">
                        <span>{{info.email}}</span>
                    </FormItem>
                </template>
                <template v-if="isRegister">
                    <PhoneSMS :isSendCode.sync="isSendCode" :phone="phoneValue" @resetCode="getNewCode" type="2" serviceType="BIND"/>
                    <FormItem class="form-item" label="昵称" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
                        <Input v-decorator="['nickName',
                        {
                            validate: [
                                {
                                    trigger: 'blur',
                                    rules: rules.nickName
                                },
                            ]
                        }
                        ]"
                        placeholder="请输入昵称"
                        />
                        <div class="form-help" v-show="showHelp.nickName"><img src="../../assets/images/icon-tip.jpg">限1-12位字符，中文或字母开头，支持中文、数字、字母、-的组合</div>
                    </FormItem>
                    <FormItem class="form-item" label="密码" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
                        <Input type="password" v-decorator="['password',
                        {
                            rules: rules.password,
                        }
                        ]"
                        placeholder="请输入密码"
                        />
                        <div class="form-help" v-show="showHelp.password"><img src="../../assets/images/icon-tip.jpg">{{this.pwdValidMsg}}</div>
                    </FormItem>
                    <FormItem class="form-item" label="确认密码" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
                        <Input type="password" v-decorator="['confirmPassword',
                        {
                            rules: rules.confirmPassword,
                        }
                        ]"
                        placeholder="请确认密码"
                        />
                        <div class="form-help" v-show="showHelp.confirmPassword"><img src="../../assets/images/icon-tip.jpg">{{this.pwdValidMsg}}</div>
                    </FormItem>
                    <FormItem class="form-item" label="绑定邮箱" :colon="false" v-bind="formItemLayoutCenter" hasFeedback>
                        <Input v-decorator="['email',
                        {
                            rules: rules.email,
                        }
                        ]"
                        placeholder="请输入邮箱"
                        />
                    </FormItem>
                </template>
                <FormItem v-bind="tailFormItemLayout" v-if="isBind || isRegister">
                    <Button class="form-button" type="primary" html-type="submit" :disabled="isDisable">保存</Button>
                    <Button class="form-button" @click="back">返回</Button>
                </FormItem>
            </Form>
        </div>
    </Frame>
</template>
<script>
import { Base64 } from 'js-base64'
import Frame from '@components/lyCommonFramework/index'
import Head from '@components/title'
import { Form, Input, Button } from 'ant-design-vue'
import PhoneSMS from '@components/sendsms/sendmobile/index'
import formUtil from '@utils/form'
import CONSTANT from '@utils/constant'
import { util } from '@utils';

export default {
    data() {
        return {
            buzzId: this.$route.query.buzzId || 0,
            buzzType: this.$route.query.businessType || 0,
            accountName: this.$route.query.accountName || '',
            bindForm: {},
            info: {},
            showHelp: {
                nickName: true,
                password: true,
                confirmPassword: true,
                phone: false,
                phoneText: ''
            },
            isBind: false,
            isRegister: false,
            validateTrigger: 'blur',
            isSendCode: false,
            type: '',
            phoneValue: '',
            isDisable: true,
            form: {},
            pwdValidMsg: this.$store.state.securityConfig.pwdValidMsg,
        }
    },
    mixins: [formUtil],
    async created() {
        util.$tracker(157, '288926',10000);
        this.info.bussinessName = this.$route.query.name || ''
        this.bindForm = this.$form.createForm(this, {
            onFieldsChange: (_, changedFields) => {
                const key = Object.keys(changedFields)[0]
                this.showHelp[key] = false
                const values = this.bindForm.getFieldsValue()
                if (this.isRegister) {
                    this.isDisable = Object.keys(values).some(v => !values[v])
                } else {
                    this.isDisable = !values.phone
                }
                // console.log(values, this.isRegister, key)
                if (this.isRegister && key === 'phone') {
                    this.isDisable = true
                }
            },
        });
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.bindForm.validateFields((errors, values) => {
                if (!errors) {
                    this.bindAccount()
                }
                return;
            });
        },
        async bindAccount() {
            let param = {}
            if (this.isBind) {
                param = {
                    phone: this.bindForm.getFieldValue('phone'),
                    buzzId: this.buzzId,
                    buzzType: this.buzzType,
                    accountName: this.accountName, 
                }
            } else {
                param = {
                    userName: this.bindForm.getFieldValue('nickName'), 
                    password: this.bindForm.getFieldValue('password'), 
                    comfirmPwd: this.bindForm.getFieldValue('confirmPassword'), 
                    phone: this.bindForm.getFieldValue('phone'), 
                    email: this.bindForm.getFieldValue('email'), 
                    buzzId: this.buzzId,
                    buzzType: this.buzzType,
                    accountName: this.accountName,
                    phoneIdentity: Base64.encode(this.bindForm.getFieldValue('phone')), 
                    phoneServiceCode: Base64.encode(CONSTANT.APPSERVICECODE_BIND), 
                    phoneVcode: Base64.encode(this.bindForm.getFieldValue('code'))
                }
            }
            const res = await this.$store.dispatch('account/save', param)
            if (res.code * 1 === 1) {
                this.$message.success('绑定成功')
                this.back()
            } else {
                this.$message.error(res.msg || '系统错误')
            }
        },
        async validateName(rule, value, cb) {
            if (value) {
                // const reg1 = /[\u4e00-\u9fa5]{4,}/g;
                // const reg2 = /^.{8,20}$/i;
                // if (reg1.test(value) || reg2.test(value)) {
                //     cb()
                // } else {
                //     cb('8-20位字符，可使用中文、字母、数字或符号的组合')
                // }
                const flag = await this.validNickName(value)
                if (!flag) {
                    cb('账户昵称需唯一')
                }
            }
            cb()
        },
        validatePassword(rule, value, cb) {
            const confirmPassword = this.bindForm.getFieldValue('confirmPassword')
            if (value && confirmPassword && value !== confirmPassword) {
                cb('两次密码输入不一致');
            } else {
                cb()
            }
        },
        compareToFirstPassword (rule, value, callback){
            const password = this.bindForm.getFieldValue('password')
            if (value && password && value !== password) {
                callback('两次密码输入不一致');
            } else {
                callback();
            }
        },
        async validatePhone(rule, value, cb) {
            if (value.length === 11) {
                const json = await this.validPhone(value)
                if (json) {
                    this.getInfoByPhone(value)
                    this.isBind = true
                    this.isRegister = false
                } else {
                    this.showHelp.phone = false
                    this.isBind = false
                    this.isRegister = true
                    // console.log('validatePhone hshshssnsnsns')
                    this.isDisable = true
                }
            }
            cb()
        },
        async validateEmail(rule, value, cb) {
            const flag = await this.validEmail(value)
            if (flag) {
                cb('邮箱已经存在')
            }
            cb()
        },
        async getInfoByPhone(phone) {
            const json = await this.$store.dispatch('account/getInfoByPhone', {phone})
            if (json.code * 1 === 1) {
                this.info = {...this.info, ...json.data}
            } else {
                this.$message.error(json.msg || '系统错误')
            }
        },
        getNewCode() {
            this.phoneValue = this.bindForm.getFieldValue('phone')
            this.isSendCode = true
        },
    },
    components: {
        Frame,
        Head,
        Form,
        FormItem: Form.Item,
        Input,
        Button,
        PhoneSMS,
    }
}
</script>
<style lang="scss">
.bindAccount{
    .ant-form-item-children{
        display: flex;
    }
}
</style>
<style lang="scss" scoped>
.form-help{
      padding-left: 7px;
      font-size: 13px;
      white-space: nowrap;
      word-break: keep-all;
      display: flex;
      align-items: center;

      img{
         width: 13px;
         height: 13px;
         margin-right: 3px;
      }

      a{
         font-size: 13px;
         color: #116CD0;
         text-decoration: underline;
         padding-left: 4px;
      }
   }
.form-button{
    margin-right: 20px;
    width: 130px;
    height: 38px;

    // &.ant-btn-primary{
    //     background: #1C7AE5;
    //     border-radius: 2px;
    //     border:0;
    // }
}
</style>
